export class PageCall {
    key: string;
    timestamp: number;
    constructor(pageCall: any) {
        this.key = pageCall.key;
        this.timestamp = pageCall.timestamp;
    }
}

export class MobileConnection {
    registrationId: number;
    supplier: string;
    carrier: string;
    driver: string;
    coDriver: string;
    numberPlate: string;
    trailerNumberPlate: string;
}

export class MobileConnectionResult {
    caseId: string;
    caseUrl: string;

    constructor(result: any) {
        this.caseId = result.caseId;
        this.caseUrl = result.caseUrl;
    }
}

export class BarcodeScan {
  value: string;

  constructor(data: any) {
    this.value = data?.value;
  }
}
